import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isNumber as _isNumber } from 'lodash';
var quartilePercentiles = [0, 0.166, 0.333, 0.5, 0.666, 0.833, 1];
/**
 *
 * @param {Object} statistics
 * @param {number} classesCount
 * @returns {Array} break class values with first and last point
 */

var getValueClassesByStatistics = function getValueClassesByStatistics(statistics) {
  var classesCount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var min = Number.parseFloat(statistics.min);
  var max = Number.parseFloat(statistics.max);
  var width = (max - min) / classesCount;
  var classes = [];

  for (var i = 0; i < classesCount + 1; i++) {
    classes[i] = min + i * width;
  }

  return classes;
};
/**
 *
 * @param {Array} classes Array of break class values with first and last point
 * @param {number} value
 * @returns {number} class index
 */


var getClassByValue = function getClassByValue(classes, value) {
  return classes[0] === value ? 0 : classes.findIndex(function (b) {
    return value <= b;
  }) - 1;
};
/**
 *
 * @param {Array} statistics
 */


var mergeAttributeStatistics = function mergeAttributeStatistics() {
  var statistics = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var mergedStatistics = {
    min: null,
    max: null,
    percentile: []
  };

  var _iterator = _createForOfIteratorHelper(statistics),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _statistic = _step.value;

      if (_statistic && _statistic.attributeStatistic) {
        mergedStatistics.min = mergedStatistics.min || mergedStatistics.min === 0 ? Math.min(mergedStatistics.min, _statistic.attributeStatistic.min) : _statistic.attributeStatistic.min;
        mergedStatistics.max = mergedStatistics.max || mergedStatistics.max === 0 ? Math.max(mergedStatistics.max, _statistic.attributeStatistic.max) : _statistic.attributeStatistic.max;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var percentilesCount = statistics[0] && statistics[0].attributeStatistic && statistics[0].attributeStatistic.percentile.length;
  var statisticsCount = statistics.length;

  for (var index = 0; index < percentilesCount; index++) {
    var sum = 0;

    var _iterator2 = _createForOfIteratorHelper(statistics),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var statistic = _step2.value;

        if (statistic && statistic.attributeStatistic) {
          sum += statistic.attributeStatistic.percentile[index];
        }
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    mergedStatistics.percentile[index] = sum / statisticsCount;
  }

  mergedStatistics.percentile[0] = mergedStatistics.min;
  mergedStatistics.percentile[mergedStatistics.percentile.length - 1] = mergedStatistics.max; //check if min and max is filled

  var minFilled = _isNumber(mergedStatistics.min);

  var maxFilled = _isNumber(mergedStatistics.max);

  return minFilled && maxFilled ? mergedStatistics : null;
};

var getClassCount = function getClassCount() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return Math.max(0, classes.length - 1);
};

var getMiddleClassValues = function getMiddleClassValues() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return classes.reduce(function (acc, val, idx, src) {
    if (idx > 0) {
      acc.push((src[idx - 1] + src[idx]) / 2);
      return acc;
    } else {
      return acc;
    }
  }, []);
};

var getClassesIntervals = function getClassesIntervals() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

  var collectedClasses = _toConsumableArray(new Set(classes));

  if (collectedClasses.length !== 1) {
    var intervals = collectedClasses.reduce(function (acc, val, idx, src) {
      if (idx > 0) {
        acc.push([src[idx - 1], src[idx]]);
      }

      return acc;
    }, []);
    return intervals;
  } else {
    //probably only one value in cartogram
    return [[collectedClasses[0], collectedClasses[0]]];
  }
};

var setClassesMinMaxFromStatistics = function setClassesMinMaxFromStatistics() {
  var classes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var statistics = arguments.length > 1 ? arguments[1] : undefined;

  var modified = _toConsumableArray(classes);

  modified[0] = statistics.min;
  modified[classes.length - 1] = statistics.max;
  return modified;
}; // rangeMap :: (Num, Num) -> (Num, Num) -> Num -> Num


var rangeMap = function rangeMap(a, b) {
  return function (s) {
    var _a = _slicedToArray(a, 2),
        a1 = _a[0],
        a2 = _a[1];

    var _b = _slicedToArray(b, 2),
        b1 = _b[0],
        b2 = _b[1]; // Scaling up an order, and then down, to bypass a potential,
    // precision issue with negative numbers.


    return ((b2 - b1) * (s - a1) / (a2 - a1) * 10 + 10 * b1) / 10;
  };
};

export default {
  getClassByValue: getClassByValue,
  getClassCount: getClassCount,
  getClassesIntervals: getClassesIntervals,
  getMiddleClassValues: getMiddleClassValues,
  getValueClassesByStatistics: getValueClassesByStatistics,
  mergeAttributeStatistics: mergeAttributeStatistics,
  quartilePercentiles: quartilePercentiles,
  rangeMap: rangeMap,
  setClassesMinMaxFromStatistics: setClassesMinMaxFromStatistics
};